// extracted by mini-css-extract-plugin
module.exports = {"root":"device-card_root__3TZ0F","imgBgStyle":"device-card_imgBgStyle__3M3dY","data":"device-card_data__2RRFV","title":"device-card_title__16O-3","type":"device-card_type__3XBW7"};